import apiService from "@/api-service";
import { BestekFilterParams, mapFilterParamsToQueryParams } from "@/components/bestek-filter/bestek-filter-params";
import HeaderedContainer from "@/components/headered-container/headered-container";
import { OvereenkomstHouderWithBestekkenCount } from "@/models/ovk";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ResponsiveContainer, BarChart, XAxis, YAxis, Bar, Tooltip } from "recharts";

export default function FrequentOvksChart(props: { allowExpand?: boolean, bestekFilterParams?: BestekFilterParams, className?: string, card?: boolean }) {
    const allowExpand = props.allowExpand === undefined ? true : props.allowExpand;
    const bestekFilterQueryParams = props.bestekFilterParams ? mapFilterParamsToQueryParams(props.bestekFilterParams) : null;

    const navigate = useNavigate();
    const [ frequentOvks, setFrequentOvks ] = useState<OvereenkomstHouderWithBestekkenCount[] | null>(null);
    const [ paramHash, setParamHash ] = useState<string>("");

    const fetch = (): void => {
        let data: { [key: string]: any } = { limit: 10 };
        if (bestekFilterQueryParams) {
            data['bestek_filter'] = bestekFilterQueryParams
        }

        apiService.post('stats/frequent-ovks', data)
            .then((response) => {
                setFrequentOvks(response.data);
            }, console.error);
    }

    useEffect(() => {
        const newParamHash = JSON.stringify(bestekFilterQueryParams ?? {});
        if (frequentOvks === null || newParamHash !== paramHash) {
            fetch();
            setParamHash(newParamHash);
        }
    })

    const tooltipFormatter = (value: any, name: string, props: any): [string, string] => {
        if (name === "bestekken_count") {
            return [ (value as number).toString(), "Aantal bestekken" ]
        }

        return ["", ""];
    }

    const handleBarClick = (data: OvereenkomstHouderWithBestekkenCount, index: number): void => {
        navigate(`/ovks/${data.id}/${data.ovk_nummer}/${data.ovk_naam}`);
    }

    const handleYAxisClick = (data: any): void => {
        const ovk = (frequentOvks ?? []).find(o => o.ovk_naam === data.value);
        if (ovk) {
            handleBarClick(ovk, data.index);
        }
    }

    return (
        <HeaderedContainer title="Meest voorkomende overeenkomsthouders" showExpand={allowExpand} onShowExpandClick={() => navigate('statistics/ovks')} className={props.className} card={props.card}>
            <ResponsiveContainer width="100%" height={300} minWidth={300}>
                <BarChart layout="vertical" data={frequentOvks ?? []} margin={{ right: 25 }}>
                    <YAxis onClick={handleYAxisClick} width={200} type="category" dataKey="ovk_naam" />
                    <XAxis type="number" hide />
                    <Tooltip formatter={tooltipFormatter} />
                    <Bar onClick={handleBarClick} dataKey="bestekken_count" fill="#009de0" radius={[0, 3, 3, 0]} label={{ position: 'right', fontSize: 11, fill: '#666' }} />
                </BarChart>
            </ResponsiveContainer>
        </HeaderedContainer>
    )
}